import React from 'react';
import { bool } from 'prop-types';

// Import components
import Nav from 'components/layout/nav/Nav';
import MobileNav from '../nav/nav_mobile/MobileNav';
import TabNav from 'components/layout/tab_nav';

// Import styled components
import { StyledHeader } from './styles';

// Import hooks
import { useDeviceInfo } from 'components/utilities';

// Import helpers
import { HEADER_QUERY } from 'helpers/variables';

const Header = ({ showMainNav }) => {
	const { isMobileDevice } = useDeviceInfo(HEADER_QUERY);

	return (
		<StyledHeader>
			<TabNav />
			{showMainNav && <>{isMobileDevice ? <MobileNav /> : <Nav />}</>}
		</StyledHeader>
	);
};

Header.propTypes = {
	showMainNav: bool.isRequired
};

export default Header;
